import { z } from 'zod';
import { PopulatedSystemEntitySuggestionSchema } from '../../entities/entity-suggestion';
export const ShadowSystemSchema = PopulatedSystemEntitySuggestionSchema.extend({
    occurrenceCount: z.number().int().min(0)
});
export const ListShadowSystemsResponseSchema = z.object({
    data: z.array(ShadowSystemSchema),
    totalRecordings: z.number().int().min(0)
});

//# sourceMappingURL=list-shadow-systems.contract.js.map